import { EnvManager } from '../utils/EnvManager';

// 获取环境变量管理器实例
const env = EnvManager.getInstance();
const AI302_ENDPOINT = 'https://api.302.ai/v1/chat/completions';

// LLM服务配置
export const LLM_CONFIG = {
    apiEndpoint: AI302_ENDPOINT,
    apiKey: env.get('VITE_OPENAI_API_KEY', ''),
    maxTokens: env.getNumber('VITE_AI_MAX_TOKENS', 4000),
    maxOutputTokens: env.getNumber('VITE_AI_MAX_OUTPUT_TOKENS', 4000),
    temperature: env.getNumber('VITE_AI_TEMPERATURE', 0.7),
    topP: 0.7,
    topK: 50,
    frequencyPenalty: 0.5,
    n: 1,
    retryOptions: {
        maxRetries: 3,
        initialDelay: 1000, // 初始延迟1秒
        maxDelay: 10000 // 最大延迟10秒
    }
};

export interface ModelConfig {
    id: string;
    name: string;
    description: string;
    vendor?: string;    // 供应商/提供者
    endpoint?: string;  // API端点
    keyName?: string;   // 环境变量中的密钥名称
}

export const MODELS: ModelConfig[] = [
    {
        id: 'grok-4-1-fast-non-reasoning',
        name: 'Grok4.1Fast',
        description: '【单次耗时6-10秒】↑响应快 ↑综合能力强',
        vendor: '302ai',
        endpoint: AI302_ENDPOINT,
        keyName: 'VITE_OPENAI_API_KEY'
    },
    {
        id: 'gemini-3-flash-preview',
        name: 'Gemini3.0Flash',
        description: '【单次耗时5-8秒】↑速度快 ↑质量均衡',
        vendor: '302ai',
        endpoint: AI302_ENDPOINT,
        keyName: 'VITE_OPENAI_API_KEY'
    }
]; 
